export default __webpack_public_path__ + "static/media/AllProductItems12.5824e202.png";